<template>
  <panel no-button="true" :title="'Create new ' + typeName + ' category'">
    <p v-if="errors.length">Please correct the following error(s):</p>
    <ul>
      <li v-for="error in errors" :key="error" style="color: red">
        {{ error }}
      </li>
    </ul>
    <form>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3"
          >Select {{ parentCategoryName }} (choose if creating
          {{ subcategoryName }})</label
        >
        <div class="col-md-9">
          <select v-model="parentId" class="form-control">
            <option value="0">No parent</option>
            <option
              v-for="category in this.parentCategories()"
              :key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Name</label>
        <div class="col-md-9">
          <input
            v-model="name"
            type="text"
            class="form-control m-b-5"
            placeholder="Enter category name"
          />
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Description</label>
        <div class="col-md-9">
          <textarea
            v-model="description"
            class="form-control"
            rows="3"
          ></textarea>
        </div>
      </div>
      <div
        v-for="(note, index) in notes"
        :key="index"
        class="form-group row m-b-15"
      >
        <label class="col-form-label col-md-3">Note #{{ index + 1 }}</label>
        <div class="col-md-8">
          <textarea v-model="note.content" class="form-control" rows="3" />
        </div>
        <div class="col-md-1">
          <b-button @click="openModal(index)" class="btn-danger pull-right"
            >Remove note</b-button
          >
        </div>
      </div>
      <div class="form-group row m-b-15">
        <div class="col-md-11" />
        <div class="col-md-1">
          <input-button
            type="button"
            label="Add note"
            @click="addNote"
            class="btn-inverse pull-right"
          />
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Picture</label>
        <div class="col-md-9">
          <vue-dropzone
            ref="imageDropzone"
            id="imageDropzone"
            :options="imageDropzoneOptions"
            @vdropzone-removed-file="imageRemoved"
            @vdropzone-success="imageSuccess"
          />
          <b-button variant="yellow" class="mt-2" @click="openImageLibrary"
            >Choose from library</b-button
          >
        </div>
      </div>
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3">Additional files</label>
        <div class="col-md-9">
          <vue-dropzone
            ref="filesDropzone"
            id="filesDropzone"
            :options="filesDropzoneOptions"
            @vdropzone-removed-file="fileRemoved"
            @vdropzone-success="fileSuccess"
          />
        </div>
      </div>
    </form>

    <hr />

    <url-button
      label="Cancel"
      :url="`/eventbank/${$route.params.type}/categories`"
      class="btn-secondary"
    />
    <input-button
      type="submit"
      label="Save and create another"
      @click="validate(true)"
      class="btn-inverse pull-right"
    />
    <input-button
      type="submit"
      label="Save"
      @click="validate(false)"
      class="btn-yellow pull-right"
    />

    <b-modal
      ref="modalAlert"
      :title="'Delete Note #' + (currentIndex + 1)"
      centered
      cancel-variant="white"
      ok-variant="danger"
      ok-title="Delete"
      v-on:ok="removeNote(currentIndex)"
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle"></i>Delete</h5>
        <p>Are you sure you want to delete Note #{{ currentIndex + 1 }}?</p>
      </div>
    </b-modal>

    <image-library-modal ref="childModal" v-bind:level="level" />
  </panel>
  <!-- end panel -->
</template>

<script>
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'
import ImageLibraryModal from '../image-library/ImageLibraryModal.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { authHeader } from '../../helpers'
import _ from 'lodash';

export default {
  name: 'CategoryCreate',
  props: ['typeId', 'categories', 'activeEvent'],
  components: {
    UrlButton,
    InputButton,
    ImageLibraryModal,
    VueDropzone: vue2Dropzone
  },
  data() {
    return {
      typeName: 'service',
      parentCategoryName: 'service category',
      subcategoryName: 'service area',
      errors: [],
      name: '',
      parentId: 0,
      description: '',
      notes: [],
      currentIndex: 0,
      level: 1,
      imageId: null,
      fileIds: [],
      dropzoneArray: [],
      imageDropzoneOptions: {
        url: process.env.VUE_APP_API_URL + '/image',
        thumbnailWidth: 175,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        acceptedFiles: 'image/jpg, image/jpeg, image/png',
        dictDefaultMessage: 'Drop an image here to upload',
        headers: authHeader()
      },
      filesDropzoneOptions: {
        url: process.env.VUE_APP_API_URL + '/file',
        thumbnailWidth: 175,
        addRemoveLinks: true,
        maxFilesize: 5,
        acceptedFiles: 'application/pdf, image/jpg, image/jpeg',
        dictDefaultMessage: 'Drop files here or click to upload',
        headers: authHeader()
      },
      isDestroying: false
    }
  },
  methods: {
    parentCategories() {
      let parentCategories = []
      this.typeName = this.$route.params.type
      switch (this.typeId) {
        case 1:
          this.parentCategoryName = 'service category'
          this.subcategoryName = 'a service area'
          break
        case 2:
          this.parentCategoryName = 'venue'
          this.subcategoryName = 'an area'
          break
        case 3:
          this.parentCategoryName = 'group'
          this.subcategoryName = 'a team'
          break
        case 4:
          this.parentCategoryName = 'stuff category'
          this.subcategoryName = 'stuff subcategory'
          break
        default:
          break
      }
      this.categories.forEach((category) => {
        if (category.type.id == this.typeId) {
          if (category.parent == null) {
            parentCategories.push(category)
          }
        }
      })
      parentCategories = _.sortBy(parentCategories, [function(sc) { return sc.name.toLowerCase(); }]);
      return parentCategories
    },
    addNote() {
      this.notes.push({ content: '' })
    },
    openModal(index) {
      this.currentIndex = index
      this.$refs['modalAlert'].show()
    },
    removeNote(index) {
      this.notes.splice(index, 1)
    },
    imageRemoved() {
      if (!this.isDestroying) {
        this.$parent.removeImage(this.imageId)
        this.imageId = null
      }
    },
    imageSuccess(imageFile, image) {
      this.imageId = image.id
    },
    imageSelected(image) {
      this.$refs.imageDropzone.removeAllFiles()
      this.imageId = image.id

      let mockFile = {
        id: this.imageId,
        size: 175,
        url: process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd
      }
      this.$refs.imageDropzone.manuallyAddFile(mockFile, mockFile.url)
    },
    openImageLibrary() {
      if (this.parentId == 0) {
        this.level = 1
      } else {
        this.level = 2
      }
      this.$refs['childModal'].$refs['modalImageLibrary'].show()
    },
    fileRemoved(file) {
      if (!this.isDestroying) {
        let index = 0
        this.dropzoneArray.forEach(function (obj, objIndex) {
          if (file.upload.uuid == obj.upload.uuid) {
            index = objIndex
          }
        })
        this.dropzoneArray = this.$refs.filesDropzone.dropzone.files
        this.$parent.removeFile(this.fileIds[index])
        this.fileIds.splice(index, 1)
      }
    },
    fileSuccess(fileFile, file) {
      this.fileIds.push(file.id)
      this.dropzoneArray = this.$refs.filesDropzone.dropzone.files
    },
    validate(createAnother) {
      this.errors = []
      if (this.name) {
        this.submit(createAnother)
      } else {
        this.errors.push('Name required!')
      }
    },
    submit(createAnother) {
      if (this.parentId == 0) {
        this.parentId = null
      }

      this.$parent.createCategoryCall(
        JSON.stringify({
          name: this.name,
          typeId: parseInt(this.typeId),
          parentId: parseInt(this.parentId),
          description: this.description,
          notes: this.notes,
          imageId: this.imageId,
          fileIds: this.fileIds,
          eventId: this.activeEvent.id
        })
      )
      if (createAnother) {
        this.$router.go()
      } else {
        this.$router.push(
          '/eventbank/' + this.$route.params.type + '/categories'
        )
      }
    }
  },
  beforeDestroy() {
    this.isDestroying = true
  }
}
</script>
